import { ApiMananger } from "actions/rtkquery";
import { OCR_BOT_MESSAGE_API_ROUTE, OCR_BOT_START_API_ROUTE } from "routes/api/endpoints";

const assistantBotApi = ApiMananger.injectEndpoints({
  endpoints: (build) => ({
    startAssistantBotSession: build.mutation({
      query: (body) => ({
        url: OCR_BOT_START_API_ROUTE,
        method: "POST",
        body,
      }),
    }),
    getAssistantBotMessages: build.query({
      query: ({ sessionId }) => ({
        url: `${OCR_BOT_MESSAGE_API_ROUTE}${sessionId}/message/`,
        method: "GET",
      }),
    }),
    sendAssistantBotMessage: build.mutation({
      query: ({ sessionId, message }) => ({
        url: `${OCR_BOT_MESSAGE_API_ROUTE}${sessionId}/message/`,
        method: "POST",
        body: { message },
      }),
    }),
  }),
  overrideExisting: false,
});

export const {
  useStartAssistantBotSessionMutation,
  useLazyGetAssistantBotMessagesQuery,
  useSendAssistantBotMessageMutation,
} = assistantBotApi;
